// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@flip/XDL/PreStyle/typography";
import { xBaseTheme } from "@flip/XDL/types";
import color from "@flip/XDL/Utilities/color";
import BreadcrumbsPresentationPropsDefault from "@insite/mobius/Breadcrumbs/presentationProps";
import { StyledButton } from "@insite/mobius/Clickable";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...BreadcrumbsPresentationPropsDefault,
        typographyProps: {
            size: 14,
            color: "text",
            ellipsis: true,
            weight: fontConfig.weight.regular,
            css: css`
                letter-spacing: 0;
                line-height: 22px;
                max-width: 200px;
                ${IconWrapper} {
                    color: inherit;
                    margin: 0 4px;
                }
            `,
        },
        css: css`
            flex-wrap: wrap;
            margin: 12px 0 20px 0;
            ${StyledButton} {
                position: relative;
                overflow: hidden;

                > ${TypographyStyle} {
                    color: ${color("text")};
                }

                &:last-child > ${TypographyStyle} {
                    font-weight: ${fontConfig.weight.semiBold};
                }
            }
        `,
    },
} as xBaseTheme["breadcrumbs"];
